import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0461929c&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=0461929c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0461929c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/home/footer.vue
// module id = null
// module chunks = 